import { colorSchemes } from "../config/colorSchemes";

export const coloredRenderer = (_instance, td, _row, _col, prop, value) => {
  if (!prop || !value) {
    td.innerHTML = `<div class="truncated"></div>`;
    return td;
  }

  const color = colorSchemes[prop][value] ?? [];

  td.style.backgroundColor = color[0];
  td.style.color = color[1];
  td.innerHTML = `<div class="truncated">${value}</div>`;
  return td;
};
